function Hero() {
  return (
    <div className="text-white h-[100%] bg-[#798880]">
      <h2 className="text-center text-4xl mt-24">
        Selamat Datang <br /> Di Web Kelompok 2
      </h2>
      <div className="flex justify-center items-center mt-20 pb-20">
        <h3 className="text-3xl font-semibold w-full pl-20">
          Manfaat Website Pengaduan
        </h3>
        <p className="text-lg w-full pr-20 text-justify">
          Kelebihan utama dari website pengaduan kami adalah kemudahan akses dan
          pencatatan tertata. Anda dapat mengaksesnya kapan saja dan di mana
          saja, sehingga tidak ada lagi hambatan dalam mengirimkan pengaduan.
          Pengaduan yang masuk akan dicatat dengan baik dan terdokumentasi,
          sehingga proses penanganannya dapat dilakukan secara sistematis.
        </p>
      </div>
    </div>
  );
}

export default Hero;
